import { useCallback, useEffect, useRef } from "react";

type TimeoutFunction = () => unknown | void;

// https://medium.com/@sergeyleschev/react-custom-hook-usetimeout-c47db1bc34b9
export function useTimeout(callback: TimeoutFunction, delay: number) {
  const savedCallback = useRef<TimeoutFunction | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Remember the latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  const set = useCallback(() => {
    timeoutRef.current = setTimeout(() => {
      if (savedCallback.current !== null) {
        savedCallback.current();
      }
    }, delay);
  }, [delay]);

  const clear = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);

  useEffect(() => {
    set();
    return clear;
  }, [delay, set, clear]);

  return { clear };
}
